
import rocketImage from '../../res/images/rocket.gif'; // Placeholder for actual images

export const portfolioData = {
    adminControl: true, // Master switch for Admin Panel visibility across the site
    about: {
        title: "Mission Commander",
        description: "I am a passionate developer exploring the universe of code. From crafting immersive web experiences to building intelligent AI systems, I strive to push the boundaries of what's possible.",
        resumeUrl: "https://drive.google.com/uc?id=YOUR_GOOGLE_DRIVE_FILE_ID", // Replace with actual ID
        skills: [
            { name: "React", level: 95 },
            { name: "Flutter", level: 90 },
            { name: "Python", level: 85 },
            { name: "OpenCV", level: 80 },
            { name: "Node.js", level: 85 },
            { name: "Firebase", level: 88 },
            { name: "TensorFlow", level: 75 }
        ]
    },
    availability: {
        status: "Open for Missions",
        nextSlot: "Dec 12, 2025",
        availabilityApiUrl: "https://script.google.com/macros/s/AKfycbxBNR24Wxc4ysZOF3uvhhlOdvBBL3ktl0K7fFPKerp5cgs4HkOIXcjr5O_HSBAOapVcOA/exec",
        calendar: [
            { day: 'Mon', status: 'busy' },
            { day: 'Tue', status: 'available' },
            { day: 'Wed', status: 'busy' },
            { day: 'Thu', status: 'available' },
            { day: 'Fri', status: 'available' },
        ]
    },
    categories: [
        {
            id: "playstore",
            title: "App Development",
            description: "Mobile applications deployed to the Google Play Store.",
            items: [
                {
                    id: "app1",
                    type: "app",
                    title: "Galactic Explorer",
                    description: "An educational app teaching astronomy to kids through interactive AR experiences.",
                    tech: ["Flutter", "ARCore"],
                    stats: { downloads: "10K+", rating: "4.8" },
                    links: { playStore: "https://play.google.com/store" },
                    image: "https://via.placeholder.com/400x200?text=Galactic+App", // Placeholder
                    featured: true
                },
                {
                    id: "app2",
                    type: "app",
                    title: "TaskNebula",
                    description: "A productivity tool for managing daily tasks with a space-themed gamification.",
                    tech: ["React Native", "Firebase"],
                    stats: { downloads: "5K+", rating: "4.5" },
                    links: { playStore: "https://play.google.com/store" },
                    image: "https://via.placeholder.com/400x200?text=Task+Nebula", // Placeholder
                }
            ]
        },
        {
            id: "python_ai",
            title: "Python & AI",
            description: "Artificial Intelligence, Machine Learning, and Automation scripts.",
            items: [
                {
                    id: "ai1",
                    type: "ai",
                    title: "Mars Rover Vision",
                    description: "Object detection system for identifying terrain hazards using OpenCV.",
                    tech: ["Python", "OpenCV", "YOLO"],
                    links: { code: "#", demo: "#" },
                    image: "https://via.placeholder.com/400x200?text=Rover+Vision", // Placeholder
                    featured: true
                },
                {
                    id: "ai2",
                    type: "ai",
                    title: "Sentiment Analyzer",
                    description: "NLP model to analyze social media sentiment trends.",
                    tech: ["Python", "NLTK", "Scikit-learn"],
                    links: { code: "#" }
                }
            ]
        },
        {
            id: "web",
            title: "Web Development",
            description: "Responsive and dynamic web applications.",
            items: [
                {
                    id: "web1",
                    type: "web",
                    title: "Portfolio v1",
                    description: "My first portfolio website showcasing early projects.",
                    tech: ["HTML", "CSS", "JavaScript"],
                    links: { live: "#", code: "#" },
                    image: rocketImage
                },
                {
                    id: "web2",
                    type: "web",
                    title: "E-Commerce Dashboard",
                    description: "A comprehensive admin dashboard for managing online stores.",
                    tech: ["React", "Redux", "Material UI"],
                    links: { live: "#", code: "#" },
                    image: "https://via.placeholder.com/400x200?text=Dashboard", // Placeholder
                    featured: true
                }
            ]
        },
        {
            id: "research",
            title: "Research Papers",
            description: "Published academic research and articles.",
            items: [
                {
                    id: "paper1",
                    type: "paper",
                    title: "Optimizing Neural Networks for Edge Devices",
                    description: "Published in IEEE Journal of AI. Discusses techniques for reducing model size without losing accuracy.",
                    date: "2024",
                    links: { read: "#" }
                },
                {
                    id: "paper1",
                    type: "paper",
                    title: "Optimizing Neural Networks for Edge Devices",
                    description: "Published in IEEE Journal of AI. Discusses techniques for reducing model size without losing accuracy.",
                    date: "2024",
                    links: { read: "#" }
                },
                {
                    id: "paper1",
                    type: "paper",
                    title: "Optimizing Neural Networks for Edge Devices",
                    description: "Published in IEEE Journal of AI. Discusses techniques for reducing model size without losing accuracy.",
                    date: "2024",
                    links: { read: "#" }
                },
                {
                    id: "paper1",
                    type: "paper",
                    title: "Optimizing Neural Networks for Edge Devices",
                    description: "Published in IEEE Journal of AI. Discusses techniques for reducing model size without losing accuracy.",
                    date: "2024",
                    links: { read: "#" }
                },
            ]
        },
        {
            id: "extensions",
            title: "Extensions & Packages",
            description: "Tools for developers: VS Code extensions, Chrome extensions, and npm/pub.dev packages.",
            items: [
                {
                    id: "ext1",
                    type: "extension",
                    title: "React Snippets Pro",
                    description: "VS Code extension providing advanced React hooks snippets.",
                    platform: "VS Code",
                    stats: { downloads: "50K+" },
                    links: { marketplace: "#", code: "#" }
                },
                {
                    id: "pkg1",
                    type: "package",
                    title: "flutter_mars_ui",
                    description: "A Flutter package for space-themed UI components.",
                    platform: "pub.dev",
                    links: { package: "#", code: "#" }
                }
            ]
        },
        {
            id: "activities",
            title: "Field Operations",
            description: "Personal logs, competitive programming, and leisure activities.",
            layout: "list", // Triggers the Zig-Zag layout
            items: [
                {
                    id: "act1",
                    type: "activity",
                    title: "Strategic Command (Chess)",
                    description: "Sharpening tactical skills on the 64-square battlefield. Rated 1200+ on Chess.com.",
                    links: { primary: "https://www.chess.com" },
                    buttonText: "Challenge Me",
                    image: "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                },
                {
                    id: "act2",
                    type: "activity",
                    title: "Linguistics (Duolingo)",
                    description: "Expanding communication protocols. Currently learning Spanish and Japanese with a 200+ day streak.",
                    links: { primary: "https://www.duolingo.com" },
                    buttonText: "View Profile",
                    image: rocketImage
                },
                {
                    id: "act3",
                    type: "activity",
                    title: "Algorithm Training (LeetCode)",
                    description: "Solving complex computational problems. Solved 300+ problems with a focus on Dynamic Programming and Graphs.",
                    links: { primary: "https://leetcode.com" },
                    buttonText: "See Stats",
                    image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                },
                {
                    id: "act4",
                    type: "activity",
                    title: "Competitive Coding (CodeChef)",
                    description: "Participating in global coding contests. 3-Star coder consistently ranking in the top 10%.",
                    links: { primary: "https://www.codechef.com" },
                    buttonText: "View Ratings",
                    // No image to test centered layout
                }
            ]
        }
    ]
};
